import React from 'react';
import './styles/App.scss';
import Header from './components/common-header/Header';
import Hero from './components/Hero/Hero';
import Intro from './components/Chapters/Intro';
import Footer from './components/common-footer/Footer';
import Hyperlink from './components/Hyperlink/Hyperlink';
import { WidthContextProvider } from './WidthContext';
import Chapter1 from './components/Chapters/Chapter1';
import Chapter2 from './components/Chapters/Chapter2';
import Chapter3 from './components/Chapters/Chapter3';
import Chapter4 from './components/Chapters/Chapter4';
import Chapter5 from './components/Chapters/Chapter5';
import RelatedContents from './components/relatedContents/RelatedContents';
function App() {
  const hyperlinkData = [
    {
      copy: 'intel.com/stories',
      href: 'https://www.intel.com/content/www/us/en/company-overview/wonderful.html'
    }
  ];
  return (
    <WidthContextProvider>
      <main className="App">
        <Header clientName={'Intel Corporation'} />
        <Hero />
        <Intro />
        <Chapter1 />
        <Chapter2 />
        <Chapter3 />
        <Chapter4 />
        <Chapter5 />
        <div className="cta">
          Find out more at <Hyperlink hyperlinkData={hyperlinkData[0]} origin="cta" />
        </div>
        <RelatedContents />
        <Footer />
      </main>
    </WidthContextProvider>
  );
}

export default App;
